/** @format */

const remoteConfig = require("./remote");
const chapterPreScreensConfig = require("../flow/chaptersPreScreensConfig");

module.exports = {
  partnerId: "casumo",
  partnerName: "Casumo",
  country: null,
  fallbackCountry: "GB",
  restrictedCountries: [
    "DE",
    "DK",
    "TT",
    "BW",
    "GG",
    "YT",
    "EE",
    "KM",
    "NG",
    "LR",
    "UZ",
    "BE",
    "JO",
    "HM",
    "TR",
    "HK",
    "ER",
    "KZ",
    "CO",
    "VE",
    "RO",
    "TJ",
    "LT",
    "YE",
    "MD",
    "RS",
    "GW",
    "KR",
    "HT",
    "GH",
    "BN",
    "BZ",
    "CZ",
    "BS",
    "ET",
    "BJ",
    "AU",
    "BA",
    "SG",
    "GN",
    "WF",
    "OM",
    "EH",
    "SI",
    "PM",
    "AD",
    "IQ",
    "GY",
    "DM",
    "NC",
    "GM",
    "MK",
    "EC",
    "US",
    "BL",
    "NE",
    "BT",
    "GP",
    "VI",
    "BD",
    "SY",
    "HR",
    "CY",
    "TL",
    "CG",
    "PT",
    "MF",
    "KP",
    "IT",
    "TM",
    "GF",
    "BO",
    "UM",
    "MR",
    "CH",
    "CX",
    "CV",
    "KH",
    "SR",
    "TD",
    "RE",
    "CD",
    "VA",
    "KG",
    "NI",
    "AL",
    "NF",
    "SD",
    "PY",
    "PF",
    "SO",
    "LA",
    "IR",
    "AG",
    "ME",
    "SK",
    "SV",
    "CF",
    "CM",
    "SN",
    "MO",
    "TF",
    "SS",
    "BG",
    "GA",
    "CI",
    "KE",
    "GL",
    "MA",
    "AQ",
    "MP",
    "ZW",
    "AO",
    "HU",
    "AZ",
    "GR",
    "CC",
    "PK",
    "BH",
    "CN",
    "LV",
    "AS",
    "PS",
    "MQ",
    "CK",
    "IL",
    "TN",
    "FO",
    "LY",
    "DJ",
    "VU",
    "FR",
    "PL",
    "BF",
    "TG",
    "PW",
    "BV",
    "NP",
    "GU",
    "BI",
    "LK",
    "PR",
    "VG",
    "SL",
    "PA",
    "MM",
    "TW",
    "TZ",
    "TK",
    "TC",
    "UG",
    "AF",
    "AX",
    "BQ",
    "IO",
    "CU",
    "GP",
    "FJ",
    "JM",
    "KI",
    "LS",
    "MV",
    "MH",
    "FM",
    "MS",
    "NA",
    "NU",
    "PN",
    "RW",
    "SH",
    "KN",
    "LC",
    "VC",
    "WS",
    "ST",
    "SC",
    "SX",
    "CW",
    "GQ",
    "MV",
    "SJ",
    "GS",
    "TO",
    "GT",
  ],
  featuredCountries: ["GB", "SE", "NO", "FI", "DK", "CA", "JP", "NZ", "IN"],
  languages: [
    "en-NZ",
    "en-IN",
    "en",
    "sv",
    "de",
    "fi",
    "no",
    "po",
    "ja",
    "nl",
    "fr",
    "es",
    "it",
    "da",
    "tr",
    "zh",
  ],
  oneInputAddressCountries: ["AE", "RO", "CN", "ES", "MT", "IE", "RU", "UA"],
  noCountrySelector: ["SE", "GB", "DK", "IN"],
  ibanCountries: [], // List of IBAN countries to check
  language: null,
  selectableCurrencies: ["sek", "eur"], // ['currency'] - not releated by countries, [{id:'usd', countries: ['ca']}] - related to countries
  fallbackLanguage: "en-GB",
  hidePasswordByDefault: ["desktop"], // accept ['mobile','desktop'] or false
  customLoginRedirectURL: "/chapter3/login",
  loginRedirectURL: (countryCode) => {
    switch (countryCode) {
      case "DE":
        return "https://www.casumo.com/de/einloggen/";
      case "CA":
        return "https://www.casumo.com/en-ca/log-in/";
      case "FI":
        return "https://www.casumo.com/fi/kirjaudu-sisaan/";
      case "NO":
        return "https://www.casumo.com/no/logg-inn/";
      case "GB":
        return "https://www.casumo.com/en-gb/log-in/";
      case "JP":
        return "https://casumo.com/ja/log-in/";
      default:
        return "https://www.casumo.es/iniciar-sesion/";
    }
  },
  loginRedirectOnOverview: true,
  forceMobileOTPDeliveryMethod: { NZ: "MOBILE", IN: "MOBILE", JP: "MOBILE" }, // accepts MOBILE=sms or DISPLAY=flash-sms, if nothing is set, it'll fallback to global api settings
  defaultGeoIPService: "regily",
  idinFieldsToCheck: ["age18"],
  passwordRules: {
    minLength: 6,
    maxLength: 99,
    letters: true,
    letterCasing: false,
    digits: false,
    specials: false,
    digitsOrSpecials: true,
    japaneseRegexPattern: {
      password: /[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ\u{3040}-\u{30ff}\u{3400}-\u{4dbf}\u{4e00}-\u{9fff}\u{f900}-\u{faff}\u{ff66}-\u{ff9f}\u{0400}-\u{04FF}\s]/u,
    },
  },
  fullNameRegExp: /[^a-zA-Zａ-ｚＡ-ＺÆÐƎƏƐƔĲŊŒẞÞǷȜæðǝəɛɣĳŋœĸſßþƿȝĄƁÇĐƊĘĦĮƘŁØƠŞȘŢȚŦŲƯY̨Ƴąɓçđɗęħįƙłøơşșţțŧųưy̨ƴÁÀÂÄǍĂĀÃÅǺĄÆǼǢƁĆĊĈČÇĎḌĐƊÐÉÈĖÊËĚĔĒĘẸƎƏƐĠĜǦĞĢƔáàâäǎăāãåǻąæǽǣɓćċĉčçďḍđɗðéèėêëěĕēęẹǝəɛġĝǧğģɣĤḤĦIÍÌİÎÏǏĬĪĨĮỊĲĴĶƘĹĻŁĽĿʼNŃN̈ŇÑŅŊÓÒÔÖǑŎŌÕŐỌØǾƠŒĥḥħıíìiîïǐĭīĩįịĳĵķƙĸĺļłľŀŉńn̈ňñņŋóòôöǒŏōõőọøǿơœŔŘŖŚŜŠŞȘṢẞŤŢṬŦÞÚÙÛÜǓŬŪŨŰŮŲỤƯẂẀŴẄǷÝỲŶŸȲỸƳŹŻŽẒŕřŗſśŝšşșṣßťţṭŧþúùûüǔŭūũűůųụưẃẁŵẅƿýỳŷÿȳỹƴźżžẓ\u{3040}-\u{30ff}\u{3400}-\u{4dbf}\u{4e00}-\u{9fff}\u{f900}-\u{faff}\u{ff66}-\u{ff9f}\u{0400}-\u{04FF}\s]/gu,
  animateOverview: false,
  animateSelectors: true,
  minimumBirthAge: { default: 18, CA: 19 }, // {default: 18} - default value of minimum birth age. {COUNTRY: VALUE} - for specific country value
  allowBackFromFirstScreen: false,
  mobileCountryPrefixSettings: {
    // options: [],
    mode: [
      ["default", "all"],
      ["GB", "one"],
    ],
    /**
     * Above accepts values:
     *  - 'all' [default and fallback]: Country and Mobile number can be from different countries, and all prefixes are allowed
     *  - 'one': Country and Mobile number have to be from the same country, and no prefix edit option
     *  - 'restrict': restrict the countries in the options property from the prefixes list
     *  - 'allow': allow only the countries in the options property to be shown in the prefixes list
     *  - Array of key-value's where key is the users country and value is 'all' or 'one'. I.e. 'restricted', or 'allow' is NOT
     *    supported when using multi country config
     */
  },
  allowFourDigitYear: false,
  waitForCallback: ["login", "reset-password"],
  bonusesOnLastStep: "all", // Array of countries to add bonus-selector to the last step or 'all' to move them all to the end
  immediateErrors: ["duplicateAccount"], // For the errors that we want to show as soon as they're resolved
  socialMedia: {
    enabled: false,
    allowOnlyLoggedIn: false,
    facebookAppId: "1940626266248961",
    googleId:
      "485912056311-pdk2vl5uis0a7cvp4ep5p6f7fuuffkl2.apps.googleusercontent.com",
    linkedInId: "7803pkog06nlor",
  },
  entercash: {
    usePaymentiq: true,
    notificationURL: "https://api.regily.com/entercash",
    alternativePersonLookup: true,
    merchantId: "20e70081bcfe49d17c9d92b43d479e7f",
    minimumDepositAmount: 100,
    maximumDepositAmount: 100000,
    lookup: {
      personLookupType: "EXTENDED_SE",
    },
    ident: {
      identType: "IDENT_SE",
    },
  },
  depositTimeout: 900,
  googleAutocompleteKey: "AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc", // set this to 'AIzaSyBrCAzXUH_wzRJEmQw9StDs2aD7GTNWsvc' or another google places API key to enable places autocomplete
  showRegilyBadge: false,
  recaptcha: {
    enabled: false,
    options: {
      // https://developers.google.com/recaptcha/docs/display#explicit_render
      // Supported in config: sitekey, theme, size, tabindex
      sitekey: "6Lf9sGMUAAAAAMLxZbaNoh0JhK7vKAkXP6R0Q-Pl",
    },
  },
  sanctionsLookup: {
    enabled: false,
    useCustomLookup: false, // Use the new sanctions lookup instead of opensanctions provider
    defaultBackendService: "sanctions",
  },
  sentry: {
    dsn: "https://1fa629cb2e264721af33e6c446362dde@sentry.io/1261142",
  },
  allowDataLookup: true,
  ChapterPreScreensConfig: chapterPreScreensConfig,
  defaultStartPath: "/auth",
  nativeApp: {
    userAgentIdentifier: "com.casumo",
    redirectUrl: "/sv/native/bankid/#playnow", // Valid URL or path
  },
  allowIncorrectEmail: true, // true to show the "it's correct" button on email validation
  remoteConfig,
  useDynamicCopy: true,
  useDynamicCopyFromOwnSubDomain: false,
  externalLinks: {
    terms: {},
    privacy: {},
    enabled: true, // used to prevent issues on gradual release
  },
  regulation: {
    enabled: true,
    countries: ["GB"],
  },
  alertBar: {
    enabled: false,
    countries: true, // Accepts boolean or an array list of allowed countries
    openLinkInExternal: false, // true to open links in new tab
    enableCollapsing: false, // allow to toggle alert content
  },
  addressProof: {
    enabled: true,
  },
  noDataPersistenceCountries: ["NL"], // to disable prefilling inputs (credentials, user...etc) based on previously entered values stored in the sessionStorage
  noPersonalDataLookupCountries: ["NL"], // to disable the address, name & gender lookup/prefilling
  blockPostalCodes: false, // can also be set in customData by value `blockPostalCodes`
  // if we want to block other than postal codes in blockedPostals.js we can add `blockedPostalCodes` to custom data, and this will overwrite default postal codes
  hideSHProvince: false, // can also be set in customData by value `hideSHProvince`
  // no province selector for German flow
  screenCompletionTracking: {
    enabled: true,
    screenNames: {
      "personal-password": "password",
      "phone-number": "phone",
      "question-gender": "gender",
      "masked-birthdate": "dob",
      "question-receive-offers": "marketing",
      gdpr: "legal",
      legal: "summary",
      "limit-selector-alternative": "limit-selector",
      "limit-selector-bankid": "limit-selector",
      "email-none-swedish-flow": "email",
      "question-terms": "terms",
      "password-animated-spanish-flow": "password",
      "password-none-swedish-or-spanish-flow": "password",
      "username-dk-flow": "username",
      "phone-number-none-swedish-flow": "phone",
      "username-none-swedish-flow": "username",
      "email-validation-none-swedish-flow": "email-validation",
      "chapter-description.three": "chapter-description",
      "email-alt": "email",
      "password-alt": "password",
      "username-alt": "username",
      "email-validation-alt": "email-validation",
      "phone-number-alt": "phone",
      "full-name-alt": "full-name",
      "phone-number-validation-alt": "phone-validation",
      "nationality-spanish-flow": "nationality",
      "full-name-none-swedish-flow": "full-name",
      "first-name-spain-flow": "first-name",
      "last-name-spain-flow": "last-name",
      "last-name-second-spain-flow": "last-name",
      "first-name-denmark-flow": "first-name",
      "last-name-denmark-flow": "last-name",
      "first-name-japanese-flow": "first-name",
      "last-name-japanese-flow": "last-name",
      "question-gender-none-swedish-flow": "gender",
      "question-country": "country",
      "question-country-none-swedish-flow": "country",
      "postal-code-none-swedish-flow": "postal-code",
      "postal-code-manual-none-swedish-flow": "postal-code-manual",
      "question-state": "state",
      "question-state-none-swedish-flow": "state",
      "question-state-india": "state-india",
      "city-none-swedish-flow": "city",
      "street-name-none-swedish-flow": "street-name",
      "house-number-none-swedish-flow": "house-number",
      "personal-number-CPR-number": "personal-number-CPR",
      "phone-number-validation-denmark-flow": "phone-validation",
      "nationality-none-swedish-flow": "nationality",
      "question-fiscal-region": "fiscal-region",
      "question-province": "province",
      "masked-birthdate-none-swedish-flow": "dob",
      "phone-number-validation-none-swedish-flow": "phone-validation",
      "phone-number-validation": "phone-validation",
      "password-animated-warning": "password-warning",
      newsletter: "newsletter",
      "question-newsletter-promo-none-swedish-flow": "question-newsletter",
      preGDPR: "legal",
      "sms-code-german-phone-validation": "otp",
      "sms-code": "otp",
      "chapter-description-idin": "idin-transition",
      "limit-selector-login.normal": "limit-selector",
      "limit-selector-require-limits": "limit-selector",
    },
  },
  otpProvider: {
    default: [], // set which provider to use by country for each sending attempt, each item in the array represent which provider to use for the corresponding attempt, e.i: ['attemp1' => otp1,'attemp2' => otp2....]
  },
};



// WEBPACK FOOTER //
// ./src/partners/config/settings.js